import GeolocationType from 'client/Security/data/GeolocationType';
import GeolocationsApi from 'client/api/v2/GeolocationApi';
import createModel from 'client/store/modules/models/createModel';

export default createModel(() => new GeolocationType(), 'id', GeolocationsApi);
